import Swiper from 'swiper/bundle'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

/**
 * Features component.
 * @author Dayne Coulson-Hoffacker
 */
export default class FeaturesSlide {
    /**
     * Constructs a new ClassStylesSlider component.
     * @param {Object} options - Options.
     * @param {HTMLElement} options.element - Container.
     */
    constructor (options) {
        this.element = options.element
        this.swiperContainer = this.element.querySelector('.swiper-container')
        this.swiperPagination = this.element.querySelector('.swiper-pagination')

        var slider = new Swiper(this.swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: false,
            pagination: {
                el: this.swiperPagination,
                clickable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                1180: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                }
            }
        })

        const currrentSlide = slider.params.slidesPerView;
        const slideCount = this.element.querySelectorAll('.swiper-slide').length;

        if(slideCount <= currrentSlide){
            slider.pagination.el.style.display = 'none'
            this.element.style.paddingBottom = '15px'
        } else  {
            slider.pagination.el.style.display = 'block'
        }

        slider.autoplay.stop()

        ScrollTrigger.create({
            trigger: this.element,
            start: 'top bottom',
            markers: false,
            scroller: 'body',
            onEnter: () => {
                slider.autoplay.start()
            }
        })



    }

}



// WEBPACK FOOTER //
// ./components/section/features/slide.js